import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../../Sass/Common.scss";
import { PrimaryDialogTitle } from "./DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "../../../Assets/Icons/PharmsmartIcon/DeleteRoundIcon.svg";
import { ReactComponent as ErrorIcon } from "../../../Assets/Icons/PharmsmartIcon/ErrorIcon.svg";
import { ReactComponent as Urgent } from "../../../Assets/Icons/PharmsmartIcon/UrgencyIcon.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "../../../Components/Common/PrimaryIcon";
import clsx from "clsx";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
          color: "red !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    paddingBottom: "0 !important",
    paddingTop: "0 !important",
    border: "0 !important",
  },

  TextBlack: {
    color: "#333 !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    width: "70%",
    margin: "0 auto !important",
  },
  TextBlackMultiple: {
    color: "#333 !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    width: "70%",
    paddingRight: "2px",
    paddingLeft: "2px",
    whiteSpace: "nowrap",
  },
  dialogWidth: {},
  assignmultiple: {
    maxWidth: "100%",
    display: "flex",
    listStyle: "none",
    flexWrap: "wrap",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    "&>p": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "fit-content",
    },
  },
  multipleList: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
}));

const ConfirmationDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    subTitle,
    warning,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box className={classes.ModalHeading}>
        <Dialog
          className="RSxs_modal"
          maxWidth={"xs"}
          open={open}
          onClose={(e) => {
            if (e.key === "Escape") {
              handleClose();
            }
          }}
          BackdropProps={{
            classes: {
              root: "root",
            },
          }}
        >
          <Box className="ConfirmPrimaryDialogTitle">
            <PrimaryDialogTitle
              handleClose={handleClose}
              icon={subTitle ? ErrorIcon : DeleteRoundIcon}
              title={"Warning"}
            />
          </Box>
          <Box className={clsx("rsNoteGrid", classes.resConfirmationBox)}>
            <DialogContent className="DialogContentBoxView">
              <Box
                className="ModalIconWidth"
                textAlign={"center"}
                justifyContent={"center"}
                paddingBottom={"10px"}
                paddingTop={"15px"}
              >
                {warning && (
                  <PrimaryIcon
                    icon={Urgent}
                    // className={classes.rsAlertIcon}
                    height="100px"
                    className="FilterRed"
                  />
                )}
                {/* {!warning && (
                  <PrimaryIcon
                    className={
                      subTitle ? classes.iconStyle : classes.iconDeleteStyle
                    }
                    height="100px"
                    icon={subTitle ? ErrorIcon : DeleteRoundIcon}
                  />
                )} */}
                {!subTitle && (
                  <>
                    <Box>
                      <Typography color={"black"}>{title}</Typography>
                    </Box>
                    <Box>
                      <Typography color={"black"}>{body}</Typography>
                    </Box>
                  </>
                )}
                {subTitle && (
                  <Box>
                    <Typography className={classes.TextBlack}>
                      {subTitle}
                    </Typography>
                  </Box>
                )}
              </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActionBtn}>
              {!subTitle && actionBtnTitle && (
                <Button
                  className="BtnRedBg"
                  variant="contained"
                  disabled={loading}
                  startIcon={
                    loading && <CircularProgress size="20px" color="white" />
                  }
                  onClick={() => handleSubmit()}
                >
                  {actionBtnTitle}
                </Button>
              )}
              <Button
                variant={!subTitle ? "outlined" : "contained"}
                onClick={handleClose}
                className={!subTitle ? "BtnRed" : "BtnRedBg"}
              >
                {!subTitle ? "Cancel" : "Okay"}
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default ConfirmationDialog;
